import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38064720&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38064720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38064720')) {
      api.createRecord('38064720', component.options)
    } else {
      api.reload('38064720', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38064720&scoped=true", function () {
      api.rerender('38064720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pop-qrcode/index.vue"
export default component.exports